import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { PageIndent } from 'core/components/Wrappers';
import ErrorPage from 'core/components/ErrorPage';

import Topics from './Topics';

import { storeOfflineEvent, sendOfflineEvents, SHOW_OFFLINE_PAGE } from './handlers';

function OfflinePage(props, context) {
  useEffect(() => {
    storeOfflineEvent(SHOW_OFFLINE_PAGE);

    if (context.counterIds && context.counterIds.yandexMetrika) {
      window.addEventListener('online', function() {
        sendOfflineEvents(context.counterIds.yandexMetrika);
      });
    }
  }, []); // eslint-disable-line

  return (
    <PageIndent>
      <Helmet>
        <title>Офлайн</title>
        <meta name='description' content='Офлайн' />
      </Helmet>
      <ErrorPage type='offline' />
      <Topics />
    </PageIndent>
  );
}

OfflinePage.contextTypes = {
  counterIds: PropTypes.shape({
    yandexMetrika: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.array,
    ]),
  }),
};

export { OfflinePage as StorybookComponent };
export default OfflinePage;
